/*
  Rodapé Motoryama (sections/rodape-motoryama.liquid). No celular, "Nossas lojas" e "Links rápidos" viram blocos que
  abrem com um toque no título. O HTML vem com os blocos abertos (o desktop, e o celular quando este script não roda);
  abaixo de 750px o script fecha os blocos. No desktop eles não fecham, e o título sai da ordem do Tab.
*/
if (!customElements.get('rodape-motoryama')) {
  customElements.define(
    'rodape-motoryama',
    class RodapeMotoryama extends HTMLElement {
      connectedCallback() {
        this.celular = window.matchMedia('(max-width: 749px)');
        this.dobras = this.querySelectorAll('.rodape__dobra');

        this.ajustar = () => {
          this.dobras.forEach((dobra) => {
            dobra.open = !this.celular.matches;
            dobra.querySelector('summary').tabIndex = this.celular.matches ? 0 : -1;
          });
        };

        this.manterAberto = (evento) => {
          if (!this.celular.matches) evento.target.open = true;
        };

        this.ajustar();
        this.celular.addEventListener('change', this.ajustar);
        this.dobras.forEach((dobra) => dobra.addEventListener('toggle', this.manterAberto));
      }

      disconnectedCallback() {
        this.celular.removeEventListener('change', this.ajustar);
      }
    }
  );
}
